import { Component, OnInit, ViewChild } from '@angular/core'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidator } from 'src/@shared/custom.validator';
import { ClrForm } from '@clr/angular';
import { LoginService } from 'src/@core/http/login';
import { UserInfoModel, LocalStorageKey, Role } from 'src/@core/http/login/login.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-forgot-password',
    templateUrl: 'forgot-password.component.html',
    styleUrls: ['forgot-password.component.scss'],
})

export class ForgotPasswordComponent implements OnInit {
    public resetForm: FormGroup;
    private redirectUrl: string;
    @ViewChild(ClrForm) clrForm;
    constructor(private formBuilder: FormBuilder,
        private service: LoginService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private toastService: ToastrService) {
        this.activatedRoute.queryParams.subscribe(params => {
            this.redirectUrl = params['redirectUrl'];
        });
    }

    ngOnInit() {
        this.checkUserInfoFromStorage()
        this.buildForm();
    }

    private buildForm() {
        this.resetForm = this.formBuilder.group({
            Email: ['', [Validators.required, Validators.email]]
        });
    }

    private checkUserInfoFromStorage() {
        const storageUser = localStorage.getItem(LocalStorageKey.CurrentUser);
        if (storageUser || storageUser !== '') {
            const userInfo = JSON.parse(storageUser) as UserInfoModel;
            if (userInfo) {
                this.redirectToPage(userInfo);
            } 
        }
    }

    public forgotBtnClick() {
        if (this.resetForm.invalid) {
            this.emailCtrl.markAsTouched();
            this.clrForm.markAsDirty();
        } else {
            this.service.forgotPassword(this.emailCtrl.value).subscribe((result: any) => {
                // store localstorage
                this.router.navigateByUrl('login');
            }, (err: any) => {
                this.toastService.error('Reset password fail, Please try again!', 'Error', {
                    timeOut: 2000,
                    toastClass: 'toast toast-default-font'
                });
            });
        }
    }

    public get emailCtrl() {
        return this.resetForm.get('Email');
    }

    private redirectToPage(user: UserInfoModel){
        if (user.isFirstLogin) {
            // redirect to T&C
            this.router.navigateByUrl('login/terms');
        }
        if (this.redirectUrl) {
            this.router.navigateByUrl(this.redirectUrl);
        }
        if (user.roles.find(r => r === Role.Admin)) {
            // redirect to admin portal
            this.router.navigateByUrl('admin');
        } else {
            this.router.navigateByUrl('customer');
        }
    }
}
